<template>
	<PublishButtonDropdown
		:nudge-top="-30"
		v-if="needPublish"
		:nameOfAction="'publish'"
		@publish-flow="startPublish"
		:showWarningIcon="showWarningIcon"
		:problematicNodes="problematicNodes"
	>
		<template #activator="{ isOpen }">
			<AnemicButton :class="{ open: isOpen }" :loading="isPublishLoading" class="publish-button pa-0" :disabled="!allowedToPublish">
				<SIcon name="publish-rocket" :height="17" class="mr-1" />
				Publish...
			</AnemicButton>
		</template>
	</PublishButtonDropdown>

	<div v-else ref="published_section">
		<AnemicButton @click="isConfigPanelOpen = true" class="published-button">
			{{ 'Published' }}
			<v-icon class="check-icon">mdi-check</v-icon>
		</AnemicButton>
		<div
			class="popover-section"
			v-if="isConfigPanelOpen"
			v-click-outside="{ handler: () => (isConfigPanelOpen = false), include: publishedSection }"
		>
			<FlowConfigPanel @close="isConfigPanelOpen = false" />
		</div>
	</div>
</template>

<script>
import FlowConfigPanel from './FlowConfigPanel';
import publishButtonProps from './PublishButton.props';
import { setPublishLoading } from '@/store/modules/selectedWorkflow/actions';
import PublishButtonDropdown from '@/components/Project/PublishButtonDropdown';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { editWorkflow, isPublishLoading } from '@/store/modules/selectedWorkflow/getters';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'PublishButton',
	props: {
		...publishButtonProps,
		needPublish: { type: Boolean },
		showCloseBuilderButton: { type: Boolean },
	},
	components: { FlowConfigPanel, PublishButtonDropdown },
	computed: {
		...mapGettersShorthand({ editWorkflow, isPublishLoading }),
	},
	methods: {
		...mapActionsShorthand({ setPublishLoading }),
		publishedSection() {
			return [this.$refs.published_section];
		},
		async startPublish({ runTestBeforePublish }) {
			if (runTestBeforePublish) {
				// After test mechanism will be final by product, we will add it here
			}
			if (!this.canPublish || !this.needPublish) {
				this.isConfigPanelOpen = true;
				return;
			}
			await AppDialogManagerService.openPublishWorkflowDialog({
				workflowId: this.editWorkflow.id,
				disableClose: this.isLoadedAsIframe,
				showCloseBuilderButton: this.showCloseBuilderButton,
				closeBuilder: () => {
					this.$emit('close-builder');
				},
			});
			if (!this.needPublish) {
				this.isConfigPanelOpen = true;
			}
		},
	},
	mounted() {
		this.setPublishLoading(false);
	},
	data() {
		return {
			isConfigPanelOpen: false,
		};
	},
};
</script>

<style scoped lang="scss">
.publish-button {
	width: 110px;
	color: var(--bg-color);
	height: 32px !important;
	font-size: 14px !important;
	border-radius: 6px !important;
	color: var(--white) !important;
	text-transform: none !important;
	background: transparent linear-gradient(97deg, #189bf9 0%, #5b5be7 100%) !important;
	&.open {
		opacity: 0.85;
	}
}

.published-button {
	color: var(--primary-color);
	width: 140px;
	height: 32px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	background: var(--ask-for-ingreation-hover-background) !important;

	.check-icon {
		color: var(--primary-color);
		font-size: 12px !important;
	}
}
.popover-section {
	right: 20px;
	position: absolute;
	top: calc(100% + 3px);
}
</style>
